import {
  useState,
} from 'react';

import {
  Button,
  EntityIcon,
  MarkdownRenderer,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from '../styled';

type Props = {
  entity: {
    id: number,
    name: string,
    description: string,
  },
  basePath?: string,
  features: {
    results: boolean,
  },
  resourceType: string,
  onSave: { (item: any): void },
  onEnterResults: { (item: any): void },
};

const Item = ({
  entity,
  basePath = '/',
  features,
  resourceType,
  onSave,
  onEnterResults,
}: Props) => {
  const [descriptionVisible, setDescriptionState] = useState(false);
  return (
    <S.Item>
      <Flex
        width="100%"
        align="center"
        justify="space-between"
      >
        <Flex
          spacing={10}
          align="center"
          justify="center"
        >
          <S.Name
            to={`${basePath}/${entity.id}`}
          >
            <EntityIcon
              resourceType={resourceType}
            />
            {entity.name}
          </S.Name>
        </Flex>
        <Flex
          align="center"
          spacing={15}
          className="is_hover_only"
        >
          {(resourceType !== 'workoutExercises' && entity.description) && (
            <Button
              ghost
              icon={`fas fa-chevron-${descriptionVisible ? 'up' : 'down'}`}
              appearance="primary"
              onClick={() => setDescriptionState(!descriptionVisible)}
            >
              See Description
            </Button>
          )}
          {(resourceType === 'personalWorkouts' && features.results) && (
            <>
              <Button
                ghost
                appearance="primary"
                onClick={() => onSave(entity)}
              >
                Schedule
              </Button>
              <Button
                ghost
                appearance="primary"
                onClick={() => onEnterResults(entity)}
              >
                Enter results
              </Button>
            </>
          )}
        </Flex>
      </Flex>
      {descriptionVisible && (
        <Flex
          width="calc(100% - 150px)"
          padding="25px 50px"
        >
          <MarkdownRenderer
            source={entity?.description}
          />
        </Flex>
      )}
    </S.Item>
  );
};

export default Item;
